import $api from "http/index";

const B = "diploma/";

export const listTopics = (params) => $api.get(`${B}topics/`, { params });
export const createTopic = (data) => $api.post(`${B}topics/`, data);
export const updateTopic = (id, data) => $api.patch(`${B}topics/${id}/`, data);
export const deleteTopic = (id) => $api.delete(`${B}topics/${id}/`);

export const listTheses = (params) => $api.get(`${B}theses/`, { params });
export const getThesis = (id) => $api.get(`${B}theses/${id}/`);
export const createThesis = (data) => $api.post(`${B}theses/`, data);
export const updateThesis = (id, data) => $api.patch(`${B}theses/${id}/`, data);
export const myThesis = () => $api.get(`${B}theses/my/`);

export const uploadVersion = (data) => {
  const fd = new FormData();
  Object.entries(data).forEach(([k, v]) => { if (v != null) fd.append(k, v); });
  return $api.post(`${B}versions/`, fd);
};

export const listAntiplag = (params) => $api.get(`${B}antiplag/`, { params });
export const createAntiplag = (data) => {
  const fd = new FormData();
  Object.entries(data).forEach(([k, v]) => { if (v != null) fd.append(k, v); });
  return $api.post(`${B}antiplag/`, fd);
};

export const listDefenses = (params) => $api.get(`${B}defenses/`, { params });
export const createDefense = (data) => $api.post(`${B}defenses/`, data);
export const finalizeDefense = (id, data) => $api.post(`${B}defenses/${id}/finalize/`, data);
